const kanbanCards = {};

export default kanbanCards;
